import React, { Component } from 'react';

import { getOS } from "./utils";
import DownloadDropdown from "./DownloadDropdown";

class DevelopmentReleases extends Component {
  constructor(props) {
    super(props);

    this.state = {
      os: getOS(),
    };
  }

  render() {
    let tbody = (
      <tbody>
        <tr>
          <th scope="row" colSpan="5">
            Loading...
          </th>
        </tr>
      </tbody>
    );

    if (this.props.releases) {
      const dateOptions = { year: "numeric", month: "short", day: "numeric" };
      const rows = this.props.releases.map((r) => {
        const versionTitle = `UI ${r.dependencies["oblac-drives"]} and MM ${r.dependencies["motion-master"]}`;

        return (
          <tr key={r.version} className="d-flex">
            <td className="col-12">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex flex-wrap flex-column">
                  <h3 className="mb-0" title={versionTitle}>
                    v{r.version}
                  </h3>
                  <span className="text-muted">
                    {r.date
                      ? new Date(r.date).toLocaleDateString(
                          "en-US",
                          dateOptions
                        )
                      : ""}
                  </span>
                </div>
                <div className="d-flex flex-column align-items-end flex-nowrap">
                  <DownloadDropdown release={r} os={this.state.os} />
                </div>
              </div>
              {r.description && (
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{ __html: r.description }}
                ></div>
              )}
            </td>
          </tr>
        );
      });
      tbody = <tbody className="bg-white">{rows}</tbody>;
    }

    return (
      <div>
        <div className="row">
          <div className="col">
            <table className="table table-releases table-development-releases shadow-sm">
              {tbody}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default DevelopmentReleases;
